import { createReducer } from "./functions";

import {
	USER_ADD_CURRENT_FILTERS,
	USER_SET_CURRENT_FILTERS,
	USER_SET_PAGINATION,
	USER_SET_FILTERS,
	USER_SET_USERS,
	USER_SET_SORT,
	USER_SET_KEY_FILTER_SELECTED,
	USER_SET_ALL_CLIENTS,
	SET_SERVICES_LIST,
	SET_ACL_LIST,
	UPDATE_USERS_LIST,
	SET_ROLES_LIST,
	USER_SET_SECTORS_LIST,
	USER_UPDATE_LOADING,
} from "../types";

const initialState = {
	users: [],
	page: 0,
	pages: 0,
	pageSize: 10,
	hasNext: true,
	filters: null,
	currentFilters: {},
	sort: { email: 1 },
	keyFilterSelected: null,
	clientsDistinct: [],
	clientsList: [],
	servicesList: [],
	aclList: [],
	rolesList: [],
	rolesDistinct: [],
	allSectorsList: [],
	updateLoading: false,
};

const setUpdateLoading = {
	[USER_UPDATE_LOADING]: (state, action) => {
		return { ...state, updateLoading: action.payload };
	},
};
const setFilters = {
	[USER_SET_FILTERS]: (state, action) => {
		let newFilters = { ...state.filters };

		newFilters[action.key] = action.values;
		return { ...state, filters: newFilters };
	},
};

const setAllClients = {
	[USER_SET_ALL_CLIENTS]: (state, action) => {
		return {
			...state,
			clientsList: action.payload,
			clientsDistinct: action.payload.map(client => client.label),
		};
	},
};

const setUsers = {
	[USER_SET_USERS]: (state, action) => {
		const page = action.payload.hasOwnProperty("page")
			? action.payload.page
			: state.page;
		const pages = action.payload.hasOwnProperty("pages")
			? action.payload.pages
			: state.pages;
		let hasNext = true;

		if (page === 0 || page === pages) {
			hasNext = false;
		}
		return { ...state, users: action.payload.docs, page, pages, hasNext };
	},
};

const setServicesList = { 
	// It would be better to put this in a separate reducer because it is not related to users and needs to be used in other components
	[SET_SERVICES_LIST]: (state, action) => {
		return {
			...state,
			servicesList: action.payload,
		};
	},
};

const setAclList = {
	[SET_ACL_LIST]: (state, action) => {
		return {
			...state,
			aclList: action.payload,
		};
	},
};

const setRolesList = {
	[SET_ROLES_LIST]: (state, action) => {
		return {
			...state,
			rolesList: action.payload,
			rolesDistinct: action.payload.map(role => role.label_fr),
		};
	},
};
const setUsersUpdated = {
	[UPDATE_USERS_LIST]: (state, action) => {
		return {
			...state,
			users: action.payload,
		};
	},
};

const setCurrentFilters = {
	[USER_SET_CURRENT_FILTERS]: (state, action) => {
		const currentFilters = { ...action.currentFilters };

		return Object.assign({}, state, {
			currentFilters: currentFilters,
		});
	},
};

const setSort = {
	[USER_SET_SORT]: (state, action) => {
		return {
			...state,
			sort: { [action.column]: action.sortOrder },
		};
	},
};
const setPagination = {
	[USER_SET_PAGINATION]: (state, action) => {
		return Object.assign({}, state, { page: action.page, pages: action.pages });
	},
};

const setKeyFilterSelected = {
	[USER_SET_KEY_FILTER_SELECTED]: (state, action) => {
		return { ...state, keyFilterSelected: action.key };
	},
};

const addCurrentFilter = {
	[USER_ADD_CURRENT_FILTERS]: (state, action) => {
		const currentFilters = state.currentFilters || {};
		currentFilters[action.key] = action.filters;
		return Object.assign({}, state, { currentFilters: currentFilters });
	},
};

const setUserAllSectorsList = {
	[USER_SET_SECTORS_LIST]: (state, action) => {
		return { ...state, allSectorsList: action.payload };
	},
};
const userReducer = createReducer(initialState, {
	...setCurrentFilters,
	...addCurrentFilter,
	...setPagination,
	...setFilters,
	...setUsers,
	...setSort,
	...setKeyFilterSelected,
	...setAllClients,
	...setServicesList,
	...setAclList,
	...setUsersUpdated,
	...setRolesList,
	...setUserAllSectorsList,
	...setUpdateLoading,
});

export default userReducer;



// WEBPACK FOOTER //
// src/redux/reducers/userReducer.js